


















































import {Component, Vue, Inject} from 'vue-property-decorator';
import {WorkersWidget} from '@v/dashboard/interfaces';
import {requestWorkersData} from '@api/widgetApi';
import WidgetBindDataSource from '@/components/widgets/base/WidgetBindDataSource.vue';
import Loading from '@c/controls/Loading.vue';

@Component({components: {WidgetBindDataSource, Loading}})
export default class WorkersWidgetComponent extends Vue {
  @Inject()
  widget!: WorkersWidget;

  currentValue: number | null = null;

  nodeId: string | null = null;
  nodeName = '';

  // TODO когда в БД появятся краткие наименования заменить
  get nodeShortName() {
    return this.nodeName;
  }

  // Цвет заголовка
  colorCaption = '#e5e5e5';

  // Показатели загрузки и наличия ошибок
  loading = true;
  error = false;

  get formattedValue() {
    if (this.currentValue == null) return 'н/д';
    if (this.currentValue > 100000) return `${this.currentValue / 1000} тыс.`;
    return `${this.currentValue}`;
  }

  // Действия при выборе узла
  onNodeSelect(data: {nodeId: string; nodeName: string}) {
    this.widget.nodeId = data.nodeId;
    this.widget.nodeName = data.nodeName;
    this.nodeId = data.nodeId;
    this.nodeName = data.nodeName;

    this.attachNode(this.widget.nodeId);
  }

  created() {
    this.nodeId = this.widget.nodeId;
    this.nodeName = this.widget.nodeName;
    this.attachNode(this.widget.nodeId);
  }

  // Привязка узла
  async attachNode(nodeId: string | null) {
    if (!nodeId) return;
    await this.getData(nodeId);
  }

  async getData(nodeId: string) {
    try {
      this.currentValue = await requestWorkersData(nodeId);
    } catch {
      this.error = true;
    } finally {
      this.loading = false;
    }
  }
}
